import React, { useCallback, useRef } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import styled from '../../styled';
import { getTranslation } from '../../utils';
import * as Badge from '../badge';
import PanelMenu, { PanelDropdownMenu, MenuTab } from '../panelMenu';
import PanelProfile from '../panelProfile';
smoothscroll.polyfill();
const scrollToTargetBottom = (
// @ts-ignore
{ current: container }, 
// @ts-ignore
{ current: target }) => {
    if (!container || !target)
        return;
    setTimeout(() => {
        if (target.offsetTop > container.scrollTop &&
            target.offsetTop + target.offsetHeight >
                container.scrollTop + container.offsetHeight) {
            container.scroll({
                top: target.offsetTop,
                left: 0,
                behavior: 'smooth',
            });
        }
    }, 350);
};
const Wrapper = styled.div `
  flex: 1;
  width: 270px;
  height: 100%;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.colors.INK_800};
  will-change: scroll-position;
`;
const Panel = ({ lang = 'zh-hant', tabs, profileTab, onboardingTab, dropdownTabs, activedTabKey, id, }) => {
    const scrollBoxRef = useRef(null);
    const handleTabToggled = useCallback((targetRef) => {
        scrollToTargetBottom(scrollBoxRef, targetRef);
    }, []);
    const handleResize = useCallback(fn => {
        window.addEventListener('resize', fn);
    }, []);
    return (React.createElement(Wrapper, { id: id, ref: scrollBoxRef },
        React.createElement(PanelProfile, { titleText: getTranslation(profileTab.titleTranslations, lang), descriptionText: getTranslation(profileTab.subTitleTranslations, lang), dropDownRender: React.createElement(PanelDropdownMenu, { tabs: dropdownTabs, lang: lang }), image: profileTab.icon, imageType: profileTab.iconType === 'KEY' ? 'ICON' : 'URI', enableShowMore: dropdownTabs.length > 1 ||
                (dropdownTabs.length > 0 &&
                    dropdownTabs[0].subs &&
                    dropdownTabs[0].subs.length > 0), onResize: handleResize }),
        onboardingTab.completed < onboardingTab.total && (React.createElement(MenuTab, { tab: Object.assign({ icon: 'Outline/Guide', target: onboardingTab.target || '_blank', renderRightIcon: () => {
                    if (onboardingTab.hideRightIcon) {
                        return React.createElement(React.Fragment, null);
                    }
                    return (React.createElement(Badge.Outline, { color: "YELLOW_400", label: onboardingTab.rightIconLabelTranslations
                            ? getTranslation(onboardingTab.rightIconLabelTranslations, lang)
                            : `${onboardingTab.completed}/${onboardingTab.total}` }));
                } }, onboardingTab), lang: lang })),
        React.createElement(PanelMenu, { tabs: tabs, lang: lang, 
            // @ts-ignore
            onTabToggled: handleTabToggled, activedTabKey: activedTabKey })));
};
export default Panel;
//# sourceMappingURL=index.js.map